export default "__VITE_ASSET__CyKVijWs__"